import React from 'react';
import styles from './ExtensionLabel.css';
import { Label } from '../Label';

interface IExtensionLabelProps {
  text: string;
}

export function ExtensionLabel({ text }: IExtensionLabelProps) {
  return (
    <div className={styles['label']}>
      <Label text={text} theme={'warning'} />
    </div>
  );
}
